import { ReactNode } from 'react'

import {
  pointsSeason2EndMonth,
  pointsSeason2StartMonth,
  pointsSeason3EndMonth,
  pointsSeason3StartMonth,
} from '@/features/points/consts'
import { selectSeasonValue } from '@/features/points/helpers'
import { Panel } from '@/ui/atoms/panel/Panel'

export function PointsHeader({ pointsSeason }: { pointsSeason: number }) {
  const pointsSeasonStartMonth = selectSeasonValue(pointsSeason, {
    2: pointsSeason2StartMonth,
    3: pointsSeason3StartMonth,
  })
  const pointsSeasonEndMonth = selectSeasonValue(pointsSeason, {
    2: pointsSeason2EndMonth,
    3: pointsSeason3EndMonth,
  })

  return (
    <div className="flex flex-row items-center justify-between">
      <h1 className="typography-heading-1">Spark Points</h1>
      <Panel
        spacing="none"
        className="flex flex-col items-start gap-1 px-3 py-1 md:flex-row md:items-center md:gap-4 md:px-4 md:py-3"
      >
        <Statistic label="Season" value={pointsSeason} />
        <div className="hidden h-3 w-px bg-quaternary md:block" />
        <Statistic label="Duration" value={`${pointsSeasonStartMonth}-${pointsSeasonEndMonth}`} />
      </Panel>
    </div>
  )
}

function Statistic({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex gap-1">
      <span className="typography-label-3 text-secondary">{label}:</span>
      <span className="typography-label-3">{value}</span>
    </div>
  )
}
